module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"default":"How Can I Help You?"},"es":{"default":"¿Le puedo ayudar en algo?"}}')
  delete Component.options._Ctor
}
